var HttpRequest = /** @class */ (function () {
    function HttpRequest(xhr, descriptor) {
        this.xhr = xhr;
        this.method = descriptor.method;
        this.url = descriptor.url;
        this.headers = descriptor.headers;
        this.queryParams = descriptor.queryParams;
        this.data = descriptor.data;
    }
    HttpRequest.prototype.setHeader = function (name, value) {
        this.headers[name] = value;
    };
    HttpRequest.prototype.setQueryParam = function (name, value) {
        this.queryParams[name] = value;
    };
    HttpRequest.prototype.getXMLHttpRequest = function () {
        return this.xhr;
    };
    HttpRequest.prototype.getResponseHeaders = function () {
        if (this.xhr.readyState == this.xhr.HEADERS_RECEIVED) {
            var headers = this.xhr.getAllResponseHeaders();
            var arr = headers.trim().split(/[\r\n]+/);
            // Create a map of header names to values
            var headerMap = {};
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var line = arr_1[_i];
                var parts = line.split(': ');
                var header = parts.shift();
                var value = parts.join(': ');
                headerMap[header] = value;
            }
            return headerMap;
        }
        return {};
    };
    HttpRequest.prototype.open = function () {
        var _this = this;
        if (this.xhr.readyState !== this.xhr.UNSENT)
            return;
        var url = this.url;
        if (this.queryParams && Object.keys(this.queryParams).length > 0) {
            url += encodeURI('?' + Object.keys(this.queryParams)
                .map(function (param) { return param + '=' + _this.queryParams[param]; })
                .join('&'));
        }
        this.xhr.open(this.method, url, true);
        this.xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        for (var header in this.headers) {
            this.xhr.setRequestHeader(header, this.headers[header]);
        }
    };
    HttpRequest.prototype.abort = function () {
        this.xhr.abort();
    };
    return HttpRequest;
}());
export { HttpRequest };
//# sourceMappingURL=http_request.js.map